<template>
    <div>
        <banner-write-link v-for="writeLayout in writeLayouts" :key="`bannerComp${writeLayout}`"
                           :bannerData="bannerData"  :writeLayout="writeLayout" ></banner-write-link>
    </div>
</template>

<script>
import BannerWriteLink from "@/components/banner/link/BannerWriteLink";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import elFileMixins from "@/mixins/elFileMixins";
import bannerUtil from "@/components/banner/bannerUtil";
import bannerValidator from "@/mixins/validators/bannerValidator";


export default {
    name: "BannerImageWriteComponent",
    mixins: [alertMixins, bannerUtil , elFileMixins, bannerValidator],
    components: {BannerWriteLink},
    inject: ['changeLoading'],
    provide() {
        return {
            bannerWriteSetData: this.setData,
        }
    },
    props: {
        bannerType: {},
        bannerKey: 0,
        // defaultApiParamSet: {default:
        // {}
        // },
    },
    data() {
        return {
            writeLayouts: [],
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            fileType: '',
            getFunc: '',
            detailApiParamsSet: {},
            bannerData: {},
            closeModalName:'',
            writeKeyName: '',
        }
    },
    created() {
        this.initFilterConfig();
        if (this.bannerKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getBanner();
        }
    },
    mounted() {
        EventBus.$on('writeBanner', this.writeBanner);

    },
    beforeDestroy() {
        EventBus.$off('writeBanner');

    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value;
        },
        initTemplateConfig() {
            let config = this.returnBannerConfig(this.bannerType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnBannerConfig(this.bannerType);
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.parsingData = config.parsingData;
            this.getFunc = config.getFunc;
            this.detailApiParamsSet = config.detailApiParamsSet;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.keyName = config.keyName;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.fileType = config.fileType;
            this.closeModalName = config.closeModalName ;
            this.writeKeyName = config.writeKeyName || '';
        },
        getBanner() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            this.changeLoading(true);
            this.$api.$banner[this.getFunc](params).then(res => res.Data.Result).then(res => {
                this.changeLoading(false);
                if (res.Info.type != 1 || res.List.length === 0) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.bannerData = res.List[0];
                this.initTemplateConfig();
            })
        },
        writeBanner() {
            let dataArr = Object.keys(this.parsingData);
            console.log(dataArr,'dataArr' );
            this.$validate(dataArr).then(success => {
                if (!success) {
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`,dataArr);
                    });
                    this.errorAlert('필수정보를 모두 입력해주세요.');
                    return;
                }
                this.changeLoading(true);
                let params = JSON.parse(JSON.stringify(this.writeApiParamSet))

                dataArr = Object.keys(this.parsingData);

                dataArr.forEach(dataKey => {
                    params[this.parsingData[dataKey]] = this[dataKey];
                    // if(!util.isEmpty(this[dataKey])){
                    //     params[this.parsingData[dataKey]] = this[dataKey];
                    // }
                })

                if (this.bannerKey != 0 && !util.isEmpty(this.writeKeyName)) {
                    params[this.writeKeyName] = this.bannerKey;
                }

                try {
                    this.$api.$banner[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                        let type = this.returnBannerType(res.Info.type);
                        if(type != true) {
                            this.changeLoading(false);
                            this.errorAlert(type);
                            return false;
                        }
                        if(!util.isEmpty(this.deleteFiles)) {
                            this.removeFiles(this.deleteFiles)
                        }

                        let checkFile = !util.isEmpty(this.fileType) && !util.isEmpty(this.files) && this.files.filter(file => file.hasOwnProperty('raw')).length > 0;
                        if(checkFile){
                            let file_id = ''
                            file_id = this.bannerKey !== 0? this.bannerKey : res.List
                            this.uploadFiles(this.files, this.fileType, file_id).then(success => {
                                this.afterFunc(res.List);
                            });
                        }
                        else{
                            this.afterFunc(res.List);
                        }
                    });
                } catch (e) {
                    this.changeLoading(false);
                    console.log(e);
                }
            })
        },
        returnBannerType(type) {
            if(type == this.writeSuccessType) {
                return true;
            }else{
                return util.isEmpty(this.writeFailTypes[type]) ? '실패입니다.' : this.writeFailTypes[type]
            }
        },
        afterFunc(key) {
            this.changeLoading(false);
            let detailKey = key;
            this.createAlert({
                title: '',
                content: this.bannerKey !== 0 ? '수정되었습니다.' : '저장되었습니다.',
                btnText: '확인',
                hide: () => {
                    if(this.directType === 'back') {
                        this.$router.back();
                        return false;
                    }
                    if(this.directType === 'modalClose'){
                        this.$modal.hide(this.closeModalName)
                        EventBus.$emit('getImageBannerList')
                        return false
                    }

                    if(this.directUrl === '') {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        this.getBanner();
                        return false;
                    }

                    let url = this.directUrl;
                    if(this.directType === 'detail') {
                        url = url+detailKey;
                    }
                    this.$router.push(url);
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
